import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetCashCenterListPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`resources/cash/centers`, { data }),
  });

export const useAddCashCenter = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/cash/centers/add`, {
        data,
        successMessage: "Cash center has been added successfully",
      }),
  });

export const useDeleteCashCenter = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/cash/centers/${data}`, {
        method: "delete",
        successMessage: "Cash center has been deleted successfully",
      }),
  });
export const useCashCenterDetails = () =>
  useMutation({
    mutationFn: (data) => client(`resources/cash/centers/${data}`),
  });
export const useEditCashCenter = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/cash/centers/edit`, {
        data,
        successMessage: "Cash center has been updated",
      }),
  });
